import { List } from 'immutable';
import {
    Component,
    OnInit,
    Input,
    ViewChild
} from '@angular/core';

import {
    BaseEntity,
    BaseInlineContainer,
    InlineContainerService,
    UserService
} from 'yt-ng-framework';

import { ActivatedRoute } from '@angular/router';
import { EOtpremnicaOpasnaMaterija } from './eotpremnica-opasna-materija';

@Component({
    selector: 'yt-eotpremnica-opasna-materija-update-container',
    templateUrl: './eotpremnica-opasna-materija-update-container.component.html',
    providers: [
        InlineContainerService
    ]
})
export class EOtpremnicaOpasnaMaterijaUpdateContainer<T extends BaseEntity>
    extends BaseInlineContainer<T>
    implements OnInit {
          izlazna: boolean = false;

    @Input() Level: 'document' | 'item' | 'attribute' = 'document';

    @ViewChild("baseDetailList", { static: false })
    baseDetailList: any;

    tempItems: List<T>;

    constructor(
        inlineContainerService: InlineContainerService<T>,
        activatedRoute: ActivatedRoute,
        userService: UserService
    ) {
        super(inlineContainerService, activatedRoute, userService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngAfterViewInit() {
        if (this.baseDetailList && this.baseDetailList.tableConfig) {
            this.izlazna=this.modelData.MainList.FormControlDataName=="eotpremnice/izeotpremnica";

            // Isključi nepotrebne akcione dugmiće u tabeli
            this.baseDetailList.tableConfig.ShowCheckBoxes = false;
            this.baseDetailList.tableConfig.DefaultListButtonsConfig.AddButtonConfig.Visible=this.izlazna;
            this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig.Visible = false;
            this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig.Visible = false;
            this.baseDetailList.tableConfig.DeleteIcon.Visible = this.izlazna;
        }
    }
}
